// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".fUsSgcZxmbmZW_3gKHSE5 {\n  padding: 2rem;\n}\n\n  .fUsSgcZxmbmZW_3gKHSE5 div {\n    display: flex;\n    justify-content: space-between;\n    width: 95%;\n  }\n", "",{"version":3,"sources":["CodeChallenge.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AAOf;;EALE;IACE,aAAa;IACb,8BAA8B;IAC9B,UAAU;EACZ","file":"CodeChallenge.css","sourcesContent":[".CodeChallenge {\n  padding: 2rem;\n\n  div {\n    display: flex;\n    justify-content: space-between;\n    width: 95%;\n  }\n}\n"]}]);
// Exports
exports.locals = {
	"CodeChallenge": "fUsSgcZxmbmZW_3gKHSE5"
};
module.exports = exports;
